module.exports = __webpack_public_path__ + "img/5-3.98dc9396.svg";